const agreementFields = [
  {
    key: 'nda_exposure',
    statement:
      'I understand that I may be exposed to protected information throughout the screening process. I fully understand any disclosure and/or exploitation of such information would result in damage to Laundry Care and its subsidiaries. *',
  },
  {
    key: 'nda_good_faith',
    statement:
      'I have read and agree to act in good faith in adherence to the above non-disclosure agreement and agreement to not compete. *',
  },
  {
    key: 'nda_confidentiality',
    statement:
      'I specifically agree to hold any and all confidential or proprietary information learned during the screening process in complete confidence. *',
  },
  {
    key: 'nda_noncompete',
    statement:
      'I specifically agree to refrain from exploiting any and all confidential or proprietary information learned during the screening process to establish, manage and/or operate any other business which directly competes with Laundry Care. *',
  },
  {
    key: 'application_certification',
    statement:
      'I certify that the information on this application is accurate and complete. I understand and agree that an incomplete form or misrepresentation is grounds for elimination from consideration for contract, or termination of contract if discovered at a later date. I authorize Laundry Care to investigate, without liability, all statements contained in this application. I understand that this document is not an offer of contract. If contracted, I will be required to furnish a signed W9 form and will not be provided with benefits including health insurance, retirement plan and paid time off. I understand that I will be an independent contractor and not an employee of Laundry Care. *',
  },
];

const qualificationFields = [
  {
    key: 'has_license',
    label:
      "Do you have a valid driver's license & the ability to provide pick-up and delivery? *",
  },
  {
    key: 'authorized_to_work',
    label:
      'As part of our hiring process, we are required to verify that all applicants are legally authorized to work in the United States. Can you confirm whether you are legally authorized to work in the U.S., and will you be able to provide documentation to support that if hired?*',
  },
  {
    key: 'can_pickup',
    label:
      'Can you provide pickups and deliveries during normal business hours? *',
  },
  {
    key: 'has_washer_dryer',
    label: 'Do you have a fully functional washer & dryer? *',
  },
  {
    key: 'understands_labels',
    label: 'Do you understand instructions on care labels including symbols? *',
  },
  {
    key: 'can_iron_airdry',
    label:
      'Providing ironing and air drying is a requirement for all Providers. Can you fulfill requests for ironing and air-drying? *',
  },
  {
    key: 'can_lift_40lbs',
    label: 'Are you able to lift & carry up to 40 pounds? *',
  },
  {
    key: 'felony_conviction',
    label: 'Have you been convicted of a felony? *',
  },
  {
    key: 'has_smartphone',
    label:
      'Do you own a smartphone that you are comfortable using & have reliable internet access? *',
  },
  {
    key: 'no_smoke',
    label:
      'I agree that no one in my home, processing area, or vehicle smoke. I understand that a smoke odor complaint is a serious issue and could result in contract inactivation. *',
  },
];
const workExperienceFields = [
  {
    key: 'previous_work_experience',
    label: 'Describe your previous work experience.',
  },
  {
    key: 'prior_experience_preparation',
    label: 'How does your prior experience prepare you for this role?',
  },
  {
    key: 'laundry_process',
    label: 'Describe your laundry process from start to finish.',
  },
  {
    key: 'order_organization',
    label: 'How do  you plan to keep orders organized?',
  },
  {
    key: 'washer_dryer_info',
    label:
      'Tell us the make, model and year of your washing machine and dryer.',
  },
  { key: 'vehicle_info', label: 'Tell us the make and model of your vehicle.' },
];
export { agreementFields, qualificationFields, workExperienceFields };
